export enum LOGIN_AUTHENTICATORS {
  USERNAME_AND_PASSWORD = 'auth-username-password-form',
  PHONE_AND_PASSWORD = 'phone-password-authenticator',
  CHANGE_TEMP_PASSWORD = 'temp-password-authenticator',
  PHONE_ACTIVATE = 'phone-auth-consent-authenticator',

  LOST_SESSSION = 'lost-session',
}

export enum OTP_AUTHENTICATORS {
  CONFIRM_SMS = 'sms-authenticator',
}

export enum SCRATCH_AUTHENTICATORS {
  CONFIRM_SCRATCH = 'scratch-authenticator',
}

export enum CUSTOMER_AUTHENTICATORS {
  BANK_ACCOUNT = 'receive-abscustid-authenticator',
}

export enum REGISTER_AUTHENTICATORS {
  LOGIN_AND_PASSWORD = 'login-password-registration',
  SECURE_QUESTIONS = 'secret-question-registration',
}

export enum RECOVER_PASSWORD_AUTHENTICATORS {
  NEW_PASSWORD = 'password-recovery',
  SECURE_ANSWERS = 'validate-secret-question',
}
